import * as dateFns from 'date-fns';
import * as utils from '@/utils/sandboxUtils';
import * as farmos from 'farmos';

export default {
  Date,
  JSON,
  Number,
  dateFns,
  utils,
  farmos,
};
